import React from 'react';
import PrivacyPolicyHero from './PrivacyPolicyHero';
import PrivacyPolicySection from './PrivacyPolicySection';
import Footer from '../../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <PrivacyPolicyHero />
      <PrivacyPolicySection />
      <Footer />
    </div>
  );
};

export default PrivacyPolicy; 